import { LoadingOverlay as MantineLoadingOverlay, Overlay, Loader, Center, Portal } from "@mantine/core";

export const CustomLoadingOverlay = ({ fullScreen, visible, overlayProps, loaderProps, ...props }) => {
  if (fullScreen) {
    if (!visible) return null;
    return (
      <Portal>
        <Overlay fixed zIndex={9999} blur={overlayProps?.blur ?? 2} backgroundOpacity={overlayProps?.backgroundOpacity ?? 0.3} />
        <Center style={{ position: "fixed", inset: 0, zIndex: 10000, pointerEvents: "none" }}>
          <Loader {...loaderProps} />
        </Center>
      </Portal>
    );
  }
  return <MantineLoadingOverlay visible={visible} overlayProps={overlayProps} loaderProps={loaderProps} {...props} />;
};

CustomLoadingOverlay.displayName = "CustomLoadingOverlay";
